import { ComponentRef, Injectable, Type } from "@angular/core";

import { Observable, Subject } from "rxjs";

export interface OutletRef<C> {
  component: Type<C>;
  inputs: Record<string, any>;
  outputs?: Record<string, any>;
  componentRef: ComponentRef<C>;
}

@Injectable({ providedIn: "root" })
export class ComponentOutletService {
  /**
   * All the necessary data about the tooltip which should be opened is being
   * sent to the outlet component through this subject.
   */
  private outletSubject: Subject<any> = new Subject<any>();

  public get outletObservable(): Observable<any> {
    return this.outletSubject.asObservable();
  }

  open<C>(opts) {
    const outletRef: OutletRef<C> = {
      ...opts,
    } as OutletRef<C>;

    this.outletSubject.next({
      ...opts,
      outletRef,
    });

    return outletRef;
  }
}
